// test2344
(2344 && 0);
